import React from 'react';
import Icon from './Icon';

export default class IconAccept extends Icon {
    renderIcon() {
        return (
            <svg viewBox="0 0 612 612" width="12px" height="12px" style={{cursor: 'pointer'}}>
                <g>
                    <polygon points="573.75,0 183.485,516.968 37.657,380.702 0,422.548 189.452,612 612,38.843"
                             fill="#9DA4B3"/>
                </g>
            </svg>
        );
    }
}